import React from 'react'
import { KB_URLS } from '../../constants/knowledge-base'
import { FilterRowItem } from './index'

interface IBuildLabelsFilterRowItemParams {
  labels: { id: string; name: string }[]
  /** false → the trigger renders disabled with a "Complete plan" tooltip covering the whole
   * button; true → the trigger is interactive (even when the labels list is empty, the dropdown
   * opens with a KB link so users learn how to create labels). */
  labelsEnabled: boolean
  /** react-intl `formatMessage`. Structural so both react-intl and mock formatters fit. */
  formatMessage: (descriptor: { id: string }) => string
  /** Pre-formatted "Clear {filter}" label for the × affordance. */
  clearLabel?: string
}

/**
 * One shared shape for the Labels filter row item - used by the Home dashboard, Wallchart,
 * Users page and Calendar page so plan-gate copy, KB link and disabled behaviour stay in one
 * place. The trigger is ALWAYS shown for discoverability; only its interactivity depends on the
 * plan.
 */
export function buildLabelsFilterRowItem(params: IBuildLabelsFilterRowItemParams): FilterRowItem {
  const { labels, labelsEnabled, formatMessage, clearLabel } = params
  const labelText = formatMessage({ id: 'app.labels' })
  return {
    id: 'labels',
    label: labelText,
    options: labels.map((label) => ({ value: label.id, label: label.name })),
    disabled: !labelsEnabled,
    lockReason: !labelsEnabled ? formatMessage({ id: 'users.table.labelsUpgradeTooltip' }) : undefined,
    clearLabel,
    emptyContent:
      labelsEnabled && labels.length === 0 ? (
        // New tab because the KB article lives on the marketing site; keeping the filter drawer
        // open behind it means the user doesn't lose their in-progress filtering context.
        <a href={KB_URLS.labelsHowTo} target="_blank" rel="noopener noreferrer">
          {formatMessage({ id: 'users.table.noLabelsYet' })}
        </a>
      ) : undefined,
  }
}
